import { io } from "socket.io-client";
import config from "../../config.json";

// Must match REST base (`config.dev`). Hardcoding production here breaks local dev:
// orders are created on localhost but sockets listened on prod → live updates never arrive.
const socket = io(config.dev, {
  transports: ["websocket", "polling"],
});

export default socket;
